import { getGameCanvasStandards, createImgDom } from '../../helpers/gameCanvasHelper';
import { roundsInfoStore } from '../../store';
import pointerPng from "../../assets/images/game/pointer.png";
import pointerCirclePng from "../../assets/images/game/pointer-circle.png";

const pointerImg = createImgDom(pointerPng);
const pointerCircleImg = createImgDom(pointerCirclePng);


const drawChartLine = () => {
  const {ctx, canvas} = getGameCanvasStandards();
  const {chartStartPoint, chartPoints, presentPoint} = roundsInfoStore;
  ctx.strokeStyle = '#FF008C';
  ctx.lineWidth = 3;

  ctx.beginPath();
  for (let i = 0; i < chartPoints.length; i++) {
    ctx.lineTo(chartStartPoint + ((i + 1) * 20), canvas.height - chartPoints[i]);
    ctx.moveTo(chartStartPoint + ((i + 1) * 20), canvas.height - chartPoints[i]);
  }
  ctx.lineTo(presentPoint.x, canvas.height - presentPoint.y);
  ctx.closePath();
  ctx.stroke();

  ctx.strokeStyle = "rgb(0,0,0)";
};


const drawChartFilled = () => {
  const {canvas, ctx} = getGameCanvasStandards();
  const {chartStartPoint, chartPoints, presentPoint} = roundsInfoStore;

  const chartFillGrd = ctx.createLinearGradient(0, canvas.height/2, 0, canvas.height*1.2);
  chartFillGrd.addColorStop(0, '#FF008C65');
  chartFillGrd.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.fillStyle = chartFillGrd;

  ctx.beginPath();
  ctx.lineTo(0, canvas.height);
  for (let i = 0; i < chartPoints.length; i++) {
    ctx.lineTo(chartStartPoint + ((i + 1) * 20), canvas.height - chartPoints[i]);
  }
  ctx.lineTo(presentPoint.x, canvas.height - presentPoint.y);
  ctx.lineTo(presentPoint.x, canvas.height);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = "rgb(0,0,0)";
};

const drawScaleNumbers = () => {
  const {canvas, ctx} = getGameCanvasStandards();
  const {presentPoint, concentrationDiff} = roundsInfoStore;
  const centerScalePoint = presentPoint.point - presentPoint.point % 20;
  const c = centerScalePoint;
  const scalePoints = [c + 60, c + 40, c + 20, c, c - 20, c - 40, c - 60];

  ctx.font = '900 13px Arial';
  ctx.fillStyle = '#FF008C65';

  scalePoints.forEach(point => {
    const y = point * 10 - concentrationDiff;
    ctx.fillRect(presentPoint.x + 3, canvas.height - y, 4, 2)
    ctx.fillText(point, presentPoint.x + 10, canvas.height - y + 5);
  });

  ctx.fillStyle = "rgb(0,0,0)";
};


export const drawPresentLine = () => {
  const {canvas, ctx} = getGameCanvasStandards();
  const {x, y, point} = roundsInfoStore.presentPoint;

  //drawing vertical line
  ctx.strokeStyle = '#FF008C65';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(x, 0);
  ctx.lineTo(x, canvas.height);
  ctx.closePath();
  ctx.stroke();

  ctx.drawImage(pointerCircleImg, x-14, canvas.height - y-14, 28, 28);
  ctx.drawImage(pointerImg, x-82, canvas.height - y-20, 75, 40);

  ctx.font = '16px Arial';
  ctx.fillStyle = 'white';

  ctx.fillText(point, x - 48 - ctx.measureText(point).width/2, canvas.height - y + 6);

  drawScaleNumbers();

  ctx.strokeStyle = "rgb(0,0,0)";
};


const drawDarknessGradient = () => {
  const {ctx} = getGameCanvasStandards();
  const grd = ctx.createLinearGradient(0, 0, 0, 400);
  grd.addColorStop(0, 'rgb(0,0,0,1)');
  grd.addColorStop(1, 'rgb(0,0,0,0)');

  ctx.fillStyle = grd;
  //ctx.fillRect(0, -100, canvas.width, canvas.height);

  ctx.strokeStyle = "rgb(0,0,0)";
};


export const chartDrawer = () => {
  drawChartLine();
  drawChartFilled();
  drawDarknessGradient();
};
